import { HomebaseUrl } from '@/constants/homebaseUrl';
import HOSTS from '@/constants/hosts';

export function homebaseBaseUrl(host: string) {
  return host === HOSTS['production'] ? HomebaseUrl.Production : HomebaseUrl.Staging;
}
